import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const WhatsAppChatButton = () => {
  const location = useLocation();
  const phoneNumber = "919626334400"; // 👈 your WhatsApp number
  const message = "Hi! I’d like to know more about Kabili Holidays.";
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // ✅ Show message only once per session
    const shown = sessionStorage.getItem("whatsappPopupShown");

    const showMessage = () => {
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 5000); // hide after 5s
    };

    if (!shown) {
      showMessage();
      sessionStorage.setItem("whatsappPopupShown", "true");
    }

    // ✅ Repeat every 2 minutes
    const interval = setInterval(showMessage, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  // 🧭 Detect if current page is a booking-related one
  const path = location.pathname;
  const isBookingPage =
    path.includes("rooms") ||
    path.includes("tour-packages") ||
    path.includes("cab-and-rental");

  // 👈 Move button to LEFT side on selected pages
  const positionStyle = isBookingPage
    ? { left: "20px", right: "auto" }
    : { right: "20px", left: "auto" };

  const popupPosition = isBookingPage
    ? { left: "90px", right: "auto" }
    : { right: "90px", left: "auto" };

  return (
    <div>
      {/* 💬 Popup message */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            bottom: window.innerWidth < 768 ? "90px" : "40px", // same heights
            ...popupPosition,
            backgroundColor: "#fff",
            color: "#333",
            padding: "10px 15px",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            zIndex: 1001,
            fontSize: "14px",
            fontWeight: "500",
            animation: "fadeInOut 5s ease forwards",
          }}
        >
          💬 Need any help?
        </div>
      )}

      {/* 🟢 WhatsApp button */}
      <div
        onClick={handleClick}
        style={{
          position: "fixed",
          bottom: window.innerWidth < 768 ? "80px" : "30px", // unchanged heights
          ...positionStyle,
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0 3px 8px rgba(0,0,0,0.3)",
          zIndex: 1000,
          transition: "transform 0.2s ease-in-out",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        title="Chat on WhatsApp"
      >
        <FaWhatsapp size={30} />
      </div>

      {/* Animation for popup */}
      <style>
        {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(10px); }
            10%, 90% { opacity: 1; transform: translateY(0); }
            100% { opacity: 0; transform: translateY(10px); }
          }
        `}
      </style>
    </div>
  );
};

export default WhatsAppChatButton;
